// src/pages/marketplace/PackagesPage.jsx
import React from 'react';
import Layout from '../../components/layout/Layout';

const PackagesPage = () => {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold mb-8">Packages</h1>
        <p>Packages page content will go here</p>
      </div>
    </Layout>
  );
};

export default PackagesPage;